import React from "react";
import { Grid, Typography, Card, CardContent, Box } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

// Skeleton component for the products carousel
export const ProductCarouselSkeleton = ({
	itemsToShow = 6,
	showTitle = true,
	titleText = "Productos",
	isLargeCarousel = false,
}) => {
	const cardWidthPercent = 100 / itemsToShow;

	return (
		<Grid
			container
			spacing={2}
			direction="column"
			style={{
				backgroundColor: "#fff",
				marginBottom: isLargeCarousel ? "30px" : "20px",
				width: "100%",
				...(showTitle ? {} : { marginTop: "40px" }),
			}}>
			{showTitle && (
				<Grid item xs={12}>
					<Skeleton variant="text" width={200} height={32} animation="wave" />
				</Grid>
			)}

			<Grid item xs={12}>
				<div
					style={{
						width: "100%",
						maxWidth: "100vw",
						overflow: "hidden",
						position: "relative",
						backgroundColor: "#fff",
					}}>
					<div
						style={{
							display: "flex",
							boxSizing: "border-box",
						}}>
						{/* Generate multiple skeleton items based on itemsToShow */}
						{Array(itemsToShow)
							.fill()
							.map((_, idx) => (
								<div
									key={idx}
									style={{
										flex: "0 0 auto",
										width: `${cardWidthPercent}%`,
										padding: "0 2px",
										boxSizing: "border-box",
									}}>
									<Card
										style={{
											padding: 0,
											maxWidth: "100%",
											margin: "0 auto",
											boxShadow: isLargeCarousel
												? "0 6px 18px rgba(0, 0, 0, 0.1)"
												: "0 2px 4px rgba(0, 0, 0, 0.1)",
										}}>
										{/* Image skeleton */}
										<Skeleton
											variant="rectangular"
											width="100%"
											height={isLargeCarousel ? 200 : 80}
											animation="wave"
										/>

										{/* Content skeleton - only show for large carousel or non-carousel mode */}
										{isLargeCarousel && (
											<CardContent
												sx={{
													"p": 0,
													"&:last-child": { paddingBottom: 0 },
													"boxShadow": "none",
												}}
												style={{
													padding: "5px 8px",
													display: "flex",
													alignItems: "flex-start",
													justifyContent: "space-between",
													gap: "8px",
												}}>
												{/* Product name skeleton */}
												<Box style={{ flex: 1 }}>
													<Skeleton
														variant="text"
														width="100%"
														height={16}
														animation="wave"
													/>
													<Skeleton variant="text" width="80%" height={16} animation="wave" />
												</Box>

												{/* Price skeleton */}
												<Skeleton variant="text" width={40} height={16} animation="wave" />
											</CardContent>
										)}
									</Card>
								</div>
							))}
					</div>
				</div>
			</Grid>
		</Grid>
	);
};

// Specific skeleton for the large carousel
export const ProductosCarruselLargoSkeleton = ({ itemsToShow = 6, showTitle = true }) => {
	return (
		<ProductCarouselSkeleton
			itemsToShow={itemsToShow}
			showTitle={showTitle}
			titleText="Productos más vendidos"
			isLargeCarousel={true}
		/>
	);
};

// Skeleton for the category/brand carousel
export const CategoryBrandCarouselSkeleton = ({ itemsCount = 3 }) => {
	return (
		<>
			{Array(itemsCount)
				.fill()
				.map((_, idx) => (
					<Grid
						key={idx}
						container
						spacing={2}
						style={{ backgroundColor: "#fff", marginBottom: "20px", width: "100%", marginTop: "5px" }}
						direction="column">
						<Grid item xs={12}>
							<Skeleton variant="text" width={150} height={32} animation="wave" />
						</Grid>

						<Grid item xs={12}>
							<div style={{ display: "flex", gap: "10px", overflow: "hidden" }}>
								{Array(11)
									.fill()
									.map((_, itemIdx) => (
										<Skeleton
											key={itemIdx}
											variant="rectangular"
											width={100}
											height={80}
											animation="wave"
											style={{ flex: "0 0 auto" }}
										/>
									))}
							</div>
						</Grid>
					</Grid>
				))}
		</>
	);
};
